import Vue from 'vue';
import VueRouter from "vue-router";
import moment from "moment";

Vue.use(VueRouter);

const BALANCO_ENERGETICO = "Balanço Energético";
const BALANCO_FINANCEIRO = "Balanço Financeiro";
const TRADUTORES = "Tradutores";
const CONCESSIONARIAS = "Concessionárias";
const FAZENDAS = "Unidades Geradoras";
const RELATORIOS = "Relatórios";


const router = new VueRouter({
    base: process.env.MIX_BASE_URL,
    mode: 'history',
    linkExactActiveClass: 'active',
    routes: [
        {
            path: '/',
            redirect: '/bemvindo',
            meta: {
                deveEstarAutenticado: true
            },
        },
        {
            path: '/bemvindo',
            name: 'bemvindo',
            component: () => import('../pages/bemvindo.vue'),
            meta: {
                deveEstarAutenticado: true,
            }
        },
        {
            path: '/visualizar-balanco',
            name: 'visualizar-balanco',
            component: () => import('../pages/balanco/home.vue'),
            meta: {
                modulo: BALANCO_ENERGETICO,
                icone: 'mdi-solar-power-variant-outline',
                deveEstarAutenticado: true,
                breadCrumb(router) {
                    const referencia = router.params.referencia;
                    const consorcio = router.params.consorcio;

                    return [
                        {
                            to: {name: 'bemvindo'},
                            text: 'Início',
                        },
                        {
                            text: 'Balanços',
                        }
                    ]
                }
            }
        },
        {
            path: '/visualizar-balanco/:referencia',
            name: 'visualizar-balanco-referencia',
            component: () => import('../pages/balanco/consorcios.vue'),
            meta: {
                modulo: BALANCO_ENERGETICO,
                deveEstarAutenticado: true,
                icone: 'mdi-solar-power-variant-outline',
                breadCrumb(router) {
                    const referencia = router.params.referencia;
                    const consorcio = router.params.consorcio;

                    return [
                        {
                            to: {name: 'bemvindo'},
                            text: 'Início',
                        },
                        {
                            text: 'Balanços',
                            to: {name: 'visualizar-balanco'}
                        },
                        {
                            text: 'Referência ' + moment(referencia, 'YYYY-MM-DD').format('MM/YYYY'),
                        }
                    ]
                }
            }
        },
        {
            path: '/visualizar-balanco/:referencia/lista',
            name: 'visualizar-balanco-referencia-lista',
            component: () => import('../pages/balanco/clientesReferencia.vue'),
            meta: {
                icone: 'mdi-solar-power-variant-outline',
                modulo: BALANCO_ENERGETICO,
                deveEstarAutenticado: true,
                breadCrumb(router) {
                    const referencia = router.params.referencia;

                    return [
                        {
                            to: {name: 'bemvindo'},
                            text: 'Início',
                        },
                        {
                            text: 'Balanços',
                            to: {name: 'visualizar-balanco'}
                        },
                        {
                            text: 'Referência ' + moment(referencia, 'YYYY-MM-DD').format('MM/YYYY'),
                        }
                    ]
                }
            }
        },
        {
            path: '/visualizar-balanco/:referencia/:consorcio',
            name: 'visualizar-balanco-referencia-consorcio',
            component: () => import('../pages/balanco/clientesConsorcio.vue'),
            meta: {
                icone: 'mdi-solar-power-variant-outline',
                deveEstarAutenticado: true,
                modulo: BALANCO_ENERGETICO,
                breadCrumb(router) {
                    const referencia = router.params.referencia;
                    const consorcio = router.params.consorcio;

                    return [
                        {
                            to: {name: 'bemvindo'},
                            text: 'Início',
                        },
                        {
                            text: 'Balanços',
                            to: {name: 'visualizar-balanco'}
                        },
                        {
                            text: 'Referência ' + moment(referencia, 'YYYY-MM-DD').format('MM/YYYY'),
                            to: {
                                name: 'visualizar-balanco-referencia',
                                params: {referencia: referencia}
                            },
                        },
                        {
                            text: consorcio,

                        },
                    ]
                }
            }
        },
        {
            path: '/visualizar-balanco/:referencia/:consorcio/:uc/:cliente_id/cliente',
            name: 'visualizar-balanco-referencia-uc',
            component: () => import('../pages/balanco/cliente.vue'),
            meta: {
                icone: 'mdi-solar-power-variant-outline',
                modulo: BALANCO_ENERGETICO,
                deveEstarAutenticado: true,
                breadCrumb(router) {
                    var referencia = router.params.referencia;
                    var consorcio = router.params.consorcio;

                    if (consorcio == 'Todos') {
                        return [
                            {
                                to: {name: 'bemvindo'},
                                text: 'Início',
                            },
                            {
                                text: 'Balanços',
                                to: {name: 'visualizar-balanco'}
                            },
                            {
                                text: 'Referência ' + moment(referencia, 'YYYY-MM-DD').format('MM/YYYY'),
                                to: {
                                    name: 'visualizar-balanco-referencia-lista',
                                    params: {referencia: referencia},
                                    query: router.query
                                },
                            },
                            {
                                text: 'Cliente: ' + router.params.uc,
                            }
                        ]
                    }

                    return [
                        {
                            to: {name: 'bemvindo'},
                            text: 'Início',
                        },
                        {
                            text: 'Balanços',
                            to: {name: 'visualizar-balanco'}
                        },
                        {
                            text: 'Referência ' + moment(referencia, 'YYYY-MM-DD').format('MM/YYYY'),
                            to: {
                                name: 'visualizar-balanco-referencia',
                                params: {referencia: referencia},
                                query: router.query
                            },
                        },
                        {
                            text: consorcio,
                            to: {
                                name: 'visualizar-balanco-referencia-consorcio',
                                params: {referencia: referencia, consorcio: consorcio}
                            }
                        },
                        {
                            text: 'Cliente: ' + router.params.uc,
                        }


                    ]
                }
            }
        },
        {
            path: '/controle-balanco',
            name: 'controle-balanco',
            component: () => import('../pages/balanco/controleBalanco.vue'),
            meta: {
                modulo: BALANCO_ENERGETICO,
                icone: 'mdi-solar-power-variant-outline',
                deveEstarAutenticado: true,
                breadCrumb(router) {

                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Setup Balanço Energético',
                        }
                    ]
                }
            }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('../pages/balanco/dashboard.vue'),
            meta: {
                deveEstarAutenticado: true,
            }
        },
        {
            path: '/tipos-resultado',
            name: 'tipos-resultado',
            component: () => import('../pages/tiposresultados/index'),
            meta: {
                deveEstarAutenticado: true,
                modulo: BALANCO_ENERGETICO,
                icone: 'mdi-solar-power-variant-outline',
                breadCrumb(router) {

                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Tipos resultados',
                        }
                    ]
                }
            }
        },
        {
            path: '/erros-balanco',
            name: 'erros-balanco',
            component: () => import('../pages/erros/erros'),
            meta: {
                deveEstarAutenticado: true,
                icone: 'mdi-solar-power-variant-outline',
                modulo: BALANCO_ENERGETICO,
                breadCrumb(router) {
                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Falhas Balanço Energético',
                        }
                    ]
                }
            }
        },
        {
            path: '/testes-conformidade',
            name: 'visualizar-testes-conformidade',
            component: () => import('../pages/testes_conformidade/ListagemTestesConformidade.vue'),
            meta: {
                deveEstarAutenticado: true,
                icone: 'mdi-solar-power-variant-outline',
                modulo: BALANCO_ENERGETICO,
                breadCrumb(router) {
                    return [
                        {
                            to: {name: 'bemvindo'},
                            text: 'Início',
                        },
                        {
                            text: 'Testes de Conformidade',
                            to: {name: 'visualizar-testes-conformidade'}
                        }
                    ]
                }
            }
        },
        {
            path: '/fazendas-ano',
            name: 'fazendas-ano',
            component: () => import('../pages/fazenda/anoFazendas.vue'),
            meta: {
                deveEstarAutenticado: true,
                modulo: FAZENDAS,
                icone: 'mdi-flash-outline',
                breadCrumb(router) {
                    return [
                        {
                            to: {name: 'bemvindo'},
                            text: 'Início',
                        },
                        {
                            text: 'Fazendas',
                        }
                    ]
                }
            }
        },
        {
            path: '/fazendas/:ano',
            name: 'fazendas',
            component: () => import('../pages/fazenda/fazenda'),
            meta: {
                icone: "mdi-flash-outline",
                modulo: FAZENDAS,
                deveEstarAutenticado: true,
                breadCrumb(router) {

                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Fazendas',
                        }
                    ]
                }
            }
        },
        {
            path: '/fazendas-setup',
            name: 'fazendas-setup',
            component: () => import('../pages/fazenda/setupFazendas.vue'),
            meta: {
                icone: "mdi-flash-outline",
                modulo: FAZENDAS,
                deveEstarAutenticado: true,
                breadCrumb(router) {

                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Setup Fazendas',
                        }
                    ]
                }
            }
        },
        {
            path: '/fazendas-setup/:uc/:id',
            name: 'fazendas-setup-ano',
            component: () => import('../pages/fazenda/geracaoFazendaAno'),
            meta: {
                icone: "mdi-flash-outline",
                modulo: FAZENDAS,
                deveEstarAutenticado: true,
                breadCrumb(router) {

                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Setup Fazendas',
                            to: {name: 'fazendas-setup'}
                        },
                        {
                            text: 'Fazenda ' + router.params.uc,
                        },
                    ]
                }
            }
        },
        {
            path: '/listagem-pre-fatura',
            name: 'listagem-pre-fatura',
            component: () => import('../pages/prefatura/listagemPreFatura.vue'),
            meta: {
                icone: "mdi-cash-multiple",
                modulo: BALANCO_FINANCEIRO,
                deveEstarAutenticado: true,
                breadCrumb(router) {
                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Listagem de pré faturas',
                        }
                    ]
                }
            }
        },
        {
            path: '/listagem-pre-fatura/:referencia',
            name: 'listagem-pre-fatura-referencia',
            component: () => import('../pages/prefatura/listagemPreFaturaPorReferencia'),
            meta: {
                deveEstarAutenticado: true,
                icone: "mdi-cash-multiple",
                modulo: BALANCO_FINANCEIRO,
                breadCrumb(router) {
                    var referencia = router.params.referencia;
                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Listagem de pré faturas',
                            to: {name: 'listagem-pre-fatura'}
                        },
                        {
                            text: 'Listagem de pré faturas ' + moment(referencia, 'YYYY-MM-DD').format('MM/YYYY'),
                        }
                    ]
                }
            }
        },
        {
            path: '/erros-financeiro',
            name: 'erros-financeiro',
            component: () => import('../pages/erros_financeiro/index'),
            meta: {
                icone: "mdi-cash-multiple",
                modulo: BALANCO_FINANCEIRO,
                deveEstarAutenticado: true,
                breadCrumb(router) {

                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Erros Balanço Financeiro',
                        }
                    ]
                }
            }
        },
        {
            path: '/descontos-extraordinarios',
            name: 'descontos-extraordinarios',
            component: () => import('../pages/financeiro/controle_descontos/ControleDescontosExtraordinarios'),
            meta: {
                deveEstarAutenticado: true,
                icone: "mdi-cash-multiple",
                modulo: BALANCO_FINANCEIRO,
                breadCrumb(router) {

                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Controle Descontos Extraordinários',
                        }
                    ]
                }
            }
        },
        {
            path: '/descontos-extraordinarios/:id',
            name: 'descontos-extraordinarios-detalhe',
            component: () => import('../pages/financeiro/controle_descontos/ListarDescontosExtraordinarios'),
            meta: {
                deveEstarAutenticado: true,
                icone: "mdi-cash-multiple",
                modulo: BALANCO_FINANCEIRO,
                breadCrumb(router) {

                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Controle Descontos Extraordinários',
                            to: {name: 'descontos-extraordinarios'}
                        },
                        {
                            text: 'Listagem Descontos Extraordinários',
                        }
                    ]
                }
            }
        },
        {
            path: '/faturas',
            name: 'faturas',
            component: () => import('../pages/faturas/faturas'),
            meta: {
                icone: "mdi-cash-multiple",
                deveEstarAutenticado: true,
                modulo: BALANCO_FINANCEIRO,
                breadCrumb(router) {

                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Gestão de Faturas',
                        }
                    ]
                }
            }
        },
        {
            path: '/faturas/:referencia',
            name: 'faturas-por-referencia',
            component: () => import('../pages/faturas/listagemFaturaPorReferencia'),
            meta: {
                icone: "mdi-cash-multiple",
                modulo: BALANCO_FINANCEIRO,
                deveEstarAutenticado: true,
                breadCrumb(router) {

                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Gestão de Faturas',
                            to: {name: 'faturas'}
                        },
                        {
                            text: 'Gestão de Faturas',
                        }
                    ]
                }
            }
        },
        {
            path: "/tradutores",
            name: "tradutores",
            component: () => import("../pages/tradutores/tradutores"),
            meta: {
                modulo: TRADUTORES,
                icone: "mdi-translate",
                deveEstarAutenticado: true,
                breadCrumb(router) {
                    return [
                        {
                            text: "Início",
                            to: {name: "bemvindo"}
                        },
                        {
                            text: "Tradutores"
                        }
                    ];
                }
            }
        },
        {
            path: "/tradutores/mes-fatura",
            name: "tradutores-mes-fatura",
            component: () => import("../pages/tradutores/mesesfatura"),
            meta: {
                modulo: TRADUTORES,
                icone: "mdi-translate",
                deveEstarAutenticado: true,
                breadCrumb(router) {
                    return [
                        {
                            text: "Início",
                            to: {name: "bemvindo"}
                        },
                        {
                            text: "Tradutores"
                        }
                    ];
                }
            }
        },
        {
            path: "/tradutores/:id",
            name: "tradutor-detalhe",
            component: () => import("../pages/tradutores/mapeador"),
            meta: {
                modulo: TRADUTORES,
                icone: "mdi-translate",
                deveEstarAutenticado: true,
                breadCrumb(router) {
                    return [
                        {
                            text: "Início",
                            to: {name: "bemvindo"}
                        },
                        {
                            text: "Tradutores",
                            to: {name: "tradutores"}
                        },
                        {
                            text: "Tradutor"
                        }
                    ];
                }
            }
        },
        {
            path: "/tradutores/:id/builder",
            name: "tradutor-builder",
            component: () => import("../pages/tradutores/builder"),
            meta: {
                modulo: TRADUTORES,
                icone: "mdi-translate",
                deveEstarAutenticado: true,
                breadCrumb(router) {
                    return [
                        {
                            text: "Início",
                            to: {name: "bemvindo"}
                        },
                        {
                            text: "Tradutores",
                            to: {name: "tradutores"}
                        },
                        {
                            text: "Builder"
                        }
                    ];
                }
            }
        },
        {
            path: "/tradutores/:id/teste",
            name: "tradutor-teste",
            component: () => import("../pages/tradutores/teste"),
            meta: {
                modulo: TRADUTORES,
                icone: "mdi-translate",
                deveEstarAutenticado: true,
                breadCrumb(router) {
                    return [
                        {
                            text: "Início",
                            to: {name: "bemvindo"}
                        },
                        {
                            text: "Tradutores",
                            to: {name: "tradutores"}
                        },
                        {
                            to: {name: "tradutor-builder", params: {id: router.params.id}},
                            text: "Builder"
                        },
                        {
                            text: "Simulador"
                        }
                    ];
                }
            }
        },
        {
            path: "/tradutores-painel",
            name: "tradutores-painel",
            component: () => import("../pages/tradutores/painel"),
            meta: {
                modulo: TRADUTORES,
                icone: "mdi-translate",
                deveEstarAutenticado: true,
                breadCrumb(router) {
                    return [
                        {
                            text: "Início",
                            to: {name: "bemvindo"}
                        },
                        {
                            text: "Painel"
                        }
                    ];
                }
            }
        },
        {
            path: '/concessionarias-setup',
            name: 'concessionarias-setup',
            component: () => import('../pages/concessionarias/SetupConcessionarias'),
            meta: {
                icone: "mdi-transmission-tower-export",
                modulo: CONCESSIONARIAS,
                deveEstarAutenticado: true,
                breadCrumb(router) {

                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Setup Concessionárias',
                        }
                    ]
                }
            }
        },
        {
            path: '/formulario-faturas-distribuidoras',
            name: 'formulario-faturas-distribuidoras',
            component: () => import('../pages/obtencao_dados/FormularioFaturasDistribuidoras.vue'),
            meta: {
                icone: "mdi-transmission-tower-export",
                modulo: CONCESSIONARIAS,
                deveEstarAutenticado: true,
                breadCrumb(router) {
                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Concessionárias',
                            to: {name: 'concessionarias-setup'}
                        },
                        {
                            text: 'Formulário de Faturas',
                        }
                    ]
                }
            }
        },
        {
            path: '/grupos-tarifarios',
            name: 'visualizar-grupos-tarifarios',
            component: () => import('../pages/grupos_tarifarios/GruposTarifarios.vue'),
            meta: {
                deveEstarAutenticado: true,
                modulo: CONCESSIONARIAS,
                icone: "mdi-transmission-tower-export",
                breadCrumb(router) {
                    return [
                        {
                            to: {name: 'bemvindo'},
                            text: 'Início',
                        },
                        {
                            text: 'Grupos Tarifários',
                            to: {name: 'grupos-tarifarios'}
                        },

                    ]
                }
            }
        },
        {
            path: '/tarifas/:concessionaria',
            name: 'visualizar-tarifas-concessionaria',
            component: () => import('../pages/tarifas/TarifaPorConcessionaria.vue'),
            meta: {
                deveEstarAutenticado: true,
                icone: "mdi-transmission-tower-export",
                modulo: CONCESSIONARIAS,
                breadCrumb(router) {
                    const concessionaria = router.params.concessionaria;

                    return [
                        {
                            to: {name: 'bemvindo'},
                            text: 'Início',
                        },
                        {
                            text: 'Setup Concessionárias',
                            to: {name: 'concessionarias-setup'}
                        },
                        {
                            text: 'Tarifas Anuais',
                            to: {
                                name: 'visualizar-tarifas-concessionaria',
                                params: {concessionaria: concessionaria}
                            },
                        },
                    ]
                }
            }
        },
        {
            path: '/auditoria',
            name: 'auditoria',
            component: () => import('../pages/auditoria/index'),
            meta: {
                deveEstarAutenticado: true,
                apenasAutorizados: true,
                icone: "mdi-shield-search",
                modulo: 'Auditoria',
                breadCrumb() {
                    return [
                        { text: 'Início', to: { name: 'bemvindo' } },
                        { text: 'Auditoria' },
                    ]
                }
            }
        },
        {
            path: '/relatorios',
            name: 'relatorios',
            component: () => import('../pages/relatorios/index'),
            meta: {
                deveEstarAutenticado: true,
                icone: "mdi-file-document-outline",
                modulo: RELATORIOS,
                breadCrumb(router) {

                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Relatórios',
                        }
                    ]
                }
            }
        },
        {
            path: '/monitoramento-faturas',
            name: 'monitoramento-faturas',
            component: () => import('../pages/monitoring/MonitoramentoFaturas.vue'),
            meta: {
                deveEstarAutenticado: true,
                icone: "mdi-chart-line",
                modulo: CONCESSIONARIAS,
                breadCrumb(router) {
                    return [
                        {
                            text: 'Início',
                            to: {name: 'bemvindo'}
                        },
                        {
                            text: 'Monitoramento de Faturas',
                        }
                    ]
                }
            }
        },

        {
            name: 'error',
            path: '/error',
            component: () => import('../pages/shared/error.vue'),
        }
    ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js